import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { PaymentV2Service, UtilService, VariablesService } from '../../shared/services';

@Component({
  selector: 'app-payment-sip-upi-timer',
  templateUrl: './payment-sip-upi-timer.component.html',
  styleUrls: ['./payment-sip-upi-timer.component.scss']
})
export class PaymentSipUpiTimerComponent implements OnInit, OnDestroy {

  timerSub: Subscription;
  countdown;
  subs: Subscription[] = [];

  constructor(
    private vars: VariablesService,
    private cdr: ChangeDetectorRef,
    public paymentV2: PaymentV2Service,
    public util: UtilService
  ) { }

  ngOnInit() {
    this.startTimer();
    this.subs.push(
      this.vars.upi_payment_status.subscribe(val => {
        if (val === 'success') {
          this.cancelPayment();
          this.util.router.navigate(['/new/payment-route'], { queryParams: this.vars.tyParams });
        } else if (val === 'failed') {
          this.cancelPayment();
        }
      })
    );
  }

  /**Cancel the payment */
  cancelPayment() {
    this.vars.upiTimer = false;
    this.vars.upi_payment_status.next('canceled');
    this.toggleTimer();
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }

  /**Toggle the timer screen after sending the upi
   * request to third party app
   */
  toggleTimer() {
    const el: any = document.getElementsByClassName('mat-bottom-sheet-container')[0];
    if (el) {
      if (this.vars.upiTimer) {
        el.setAttribute('style', 'max-height: 100vh !important; height: 100vh; border-radius: 0px !important');
      } else {
        el.setAttribute('style', 'max-height: 80vh; height: auto; border-radius: 8px 8px 0px 0px');
      }
    }
    this.cdr.detectChanges();
  }

  /**Countdown timer */
  startTimer(duration = 7 * 60) {
    this.timerSub = timer(0, 1000).pipe(
      take(duration),
      map(() => {
        if (duration <= 1) {
          this.cancelPayment();
        }
        return duration--;
      }),
    ).subscribe(res => {
      const seconds = Math.round(res % 60).toString();
      const minute = '0' + Math.floor(res / 60);
      this.countdown = `${minute} : ${seconds.length < 2 ? '0'.concat(seconds) : seconds}`;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }
}
